/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Automatic_Backup_SaveInputs */

const en_automatic_backup_save = /** @type {(inputs: Automatic_Backup_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automatic Backup & Save`)
};

const fr_automatic_backup_save = /** @type {(inputs: Automatic_Backup_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sauvegarde automatique et enregistrement`)
};

const de_automatic_backup_save = /** @type {(inputs: Automatic_Backup_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automatische Sicherung und Speicherung`)
};

const it_automatic_backup_save = /** @type {(inputs: Automatic_Backup_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Backup e salvataggio automatici`)
};

const ru_automatic_backup_save = /** @type {(inputs: Automatic_Backup_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Автоматическое резервное копирование и сохранение`)
};

const es_automatic_backup_save = /** @type {(inputs: Automatic_Backup_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copia de seguridad y guardado automáticos`)
};

const zh_cn2_automatic_backup_save = /** @type {(inputs: Automatic_Backup_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自动备份和保存`)
};

const ja_automatic_backup_save = /** @type {(inputs: Automatic_Backup_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自動バックアップと保存`)
};

const hi_automatic_backup_save = /** @type {(inputs: Automatic_Backup_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्वचालित बैकअप और सेव`)
};

const pt_pt2_automatic_backup_save = /** @type {(inputs: Automatic_Backup_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Backup e salvamento automáticos`)
};

/**
* | output |
* | --- |
* | "Automatic Backup & Save" |
*
* @param {Automatic_Backup_SaveInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const automatic_backup_save = /** @type {((inputs?: Automatic_Backup_SaveInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Automatic_Backup_SaveInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_automatic_backup_save(inputs)
	if (locale === "de") return de_automatic_backup_save(inputs)
	if (locale === "it") return it_automatic_backup_save(inputs)
	if (locale === "ru") return ru_automatic_backup_save(inputs)
	if (locale === "es") return es_automatic_backup_save(inputs)
	if (locale === "zh-CN") return zh_cn2_automatic_backup_save(inputs)
	if (locale === "ja") return ja_automatic_backup_save(inputs)
	if (locale === "hi") return hi_automatic_backup_save(inputs)
	if (locale === "pt-PT") return pt_pt2_automatic_backup_save(inputs)
	return en_automatic_backup_save(inputs)
});